import { mkSubscription } from 'data/subscriptions/subscriptionsTypes';
import { DateTime } from 'luxon';
import { getLogger } from 'utils/logger';
const log = getLogger('data/subscriptions/helpers.js');

export function getSubscriptionsOverride() {
  let subscriptions;

  const subscriptionsJSON = localStorage.getItem('subscriptionsOverride');
  let subscriptionsOverride;
  try {
    subscriptionsOverride = JSON.parse(subscriptionsJSON);
  } catch (e) {
    log.error(e);
  }
  if (Array.isArray(subscriptionsOverride)) {
    subscriptions = subscriptionsOverride.map((subscription) => mkSubscription({
      effectiveAt: DateTime.local().toISO(),
      expireAt: DateTime.local().plus({ years: 1 }).toISO(),
      expireOn: DateTime.local().plus({ years: 1 }).toISODate(),
      createdAt: DateTime.local().toISO(),
      ...subscription,
    }));
  }

  return subscriptions;
}
